export const environment = {
  VERSION: '"0.1.20"',
  title: 'Entorno de producción',
  production: true,
  API: 'https://erp.aparcandgo.com/api',
  ERP: 'https://erp.aparcandgo.com',
  PCIAPI: 'https://pci-1.aparcandgo.com',
  PUBLIC_URL: 'https://www.aparcandgo.com',
  facebookAppId: '1214142821930502',
  googleClientId:
    '253346007982-kj3lcfrj35u6jci7jrngrnf66nlqpgcr.apps.googleusercontent.com',
  facebookVersion: 'v3.2',
  googleAnalytics: 'UA-26895931-1',
  googleTagManager: 'GTM-KXH5BXS',
  googleMerchantId: '193046350',
  maps_apiKey: 'AIzaSyBZp7WfN6DyKraqmMv2Dh3Ng9H92VdaUds',
  firebaseConfig: {
    apiKey: 'AIzaSyBZp7WfN6DyKraqmMv2Dh3Ng9H92VdaUds',
    authDomain: 'test-aparcandgo.firebaseapp.com',
    databaseURL: 'https://test-aparcandgo.firebaseio.com',
    projectId: 'test-aparcandgo',
    storageBucket: 'test-aparcandgo.appspot.com',
    messagingSenderId: '253346007982',
  },
  activeCampaignId: '68359332',
};
